import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.imprint'), path: '/impressum' },
    { label: t('footer.contact'), path: '/contact' },
    { label: t('footer.privacy'), path: '/datenschutz' },
  ];

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Left: Logo and links */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="flex flex-col leading-none">
                <span className="font-heading text-2xl font-bold tracking-tight text-white">
                  BOCK
                </span>
                <span className="text-[10px] font-body tracking-[0.2em] uppercase text-white/60">
                  Maschinenfabrik
                </span>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Right: Social and badges */}
          <div className="flex items-center gap-6">
            <a
              href="https://www.youtube.com/user/MaschinenfabrikBock"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-1 text-white/60 hover:text-white transition-colors"
            >
              <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
                <i className="ri-youtube-line text-lg"></i>
              </div>
              <span className="text-[10px] uppercase tracking-wider">{t('footer.youtube')}</span>
            </a>
            <div className="flex flex-col items-center gap-1">
              <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-lg text-accent-400"></i>
              </div>
              <span className="text-[10px] uppercase tracking-wider text-accent-400">
                {t('footer.madeInGermany')}
              </span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            &copy; 2012 - 2026 {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-[10px] text-white/30 uppercase tracking-wider">
              Made in Germany
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}